import {
    NEWSFLASH_DETAILS_FAIL,
    NEWSFLASH_DETAILS_REQUEST,
    NEWSFLASH_DETAILS_SUCCESS,
    NEWSFLASH_LOGIN_FAIL,
    NEWSFLASH_LOGIN_REQUEST,
    NEWSFLASH_LOGIN_SUCCESS,
    NEWSFLASH_LOGOUT,
    
    NEWSFLASH_REGISTER_FAIL,
    NEWSFLASH_REGISTER_REQUEST,
    NEWSFLASH_REGISTER_SUCCESS,

    NEWSFLASH_UPDATE_PROFILE_REQUEST,
    NEWSFLASH_UPDATE_PROFILE_SUCCESS,
    NEWSFLASH_UPDATE_PROFILE_FAIL,
    NEWSFLASH_DETAILS_RESET,
    NEWSFLASH_LIST_FAIL,
    NEWSFLASH_LIST_REQUEST,
    NEWSFLASH_LIST_SUCCESS,
    NEWSFLASH_LIST_RESET,
    NEWSFLASH_DELETE_REQUEST,
    NEWSFLASH_DELETE_SUCCESS,
    NEWSFLASH_DELETE_FAIL,
    NEWSFLASH_UPDATE_RESET,
    NEWSFLASH_UPDATE_REQUEST,
    NEWSFLASH_UPDATE_SUCCESS,
    NEWSFLASH_UPDATE_FAIL
} from "../constants/newsflashConstants"

export const newsflashLoginReducer = (state = {}, action) => {
    switch (action.type) {
        case NEWSFLASH_LOGIN_REQUEST:
            return { loading: true }
        case NEWSFLASH_LOGIN_SUCCESS:
            return { loading: false, newsflashInfo: action.payload }
        case NEWSFLASH_LOGIN_FAIL:
            return { loading: false, error: action.payload }
        case NEWSFLASH_LOGOUT:
            return {}
        default:
            return state
    }
}

export const newsflashRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case NEWSFLASH_REGISTER_REQUEST:
            return { loading: true }
        case NEWSFLASH_REGISTER_SUCCESS:
            return { loading: false, newsflashInfo: action.payload }
        case NEWSFLASH_REGISTER_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const newsflashDetailsReducer = (state = { newsflash: {} }, action) => {
    switch (action.type) {
        case NEWSFLASH_DETAILS_REQUEST:
            return { ...state, loading: true }
        case NEWSFLASH_DETAILS_SUCCESS:
            return { loading: false, newsflash: action.payload }
        case NEWSFLASH_DETAILS_FAIL:
            return { loading: false, error: action.payload }
        case NEWSFLASH_DETAILS_RESET:
            return { newsflash: {} }
        default:
            return state
    }
}

export const newsflashUpdateProfileReducer = (state = {}, action) => {
    switch (action.type) {
        case NEWSFLASH_UPDATE_PROFILE_REQUEST:
            return { ...state, loading: true }
        case NEWSFLASH_UPDATE_PROFILE_SUCCESS:
            return { loading: false, success: true, newsflashInfo: action.payload }
        case NEWSFLASH_UPDATE_PROFILE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const newsflashListeReducer = (state = { newsflashs: [] }, action) => {
    switch (action.type) {
        case NEWSFLASH_LIST_REQUEST:
            return { loading: true }
        case NEWSFLASH_LIST_SUCCESS:
            return { loading: false, newsflashs: action.payload }
        case NEWSFLASH_LIST_FAIL:
            return { loading: false, error: action.payload }
        case NEWSFLASH_LIST_RESET:
            return { newsflashs: [] }
        default:
            return state
    }
}

export const newsflashDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case NEWSFLASH_DELETE_REQUEST:
            return { loading: true }
        case NEWSFLASH_DELETE_SUCCESS:
            return { loading: false, success: true }
        case NEWSFLASH_DELETE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const newsflashUpdateReducer = (state = { newsflash: {} }, action) => {
    switch (action.type) {
        case NEWSFLASH_UPDATE_REQUEST:
            return { loading: true }
        case NEWSFLASH_UPDATE_SUCCESS:
            return { loading: false, success: true }
        case NEWSFLASH_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        case NEWSFLASH_UPDATE_RESET:
            return {
                NEWSFLASH: {}
            }
        default:
            return state
    }
}